import React from 'react';
import { Dispatch } from 'hellospa/redux/types';
import { useDispatch } from 'react-redux';
import * as actions from 'hellospa/page/prep-and-send/data/actions';
import { FormattedMessage } from 'react-intl';
import Body from 'hellospa/foundation/typography/body';
import delay from 'hellospa/common/utils/delay';
import { Source } from '.';
import HelloModal from 'common/components/hello-modal';
import { appendQueryParameters } from 'hellospa/common/utils/fetch';
import { getCSRFToken } from 'hellospa/hs-fetch';

// This is exported from here so that it can be spied on in tests
export function openContactImport(source: Source) {
  if (!process.env.IS_STORYBOOK && process.env.NODE_ENV !== 'test') {
    const importUrl = appendQueryParameters('/account/contactImport', {
      redirect_csrf: getCSRFToken(),
      type: source,
      pending: 1,
    });
    const w = window.open(importUrl, '_blank', 'height=500,width=600');
    w!.opener = null;
  }
}

const POLL_TIMEOUT = 5 * 60 * 1000;
export type WaitingProps = {
  source: Source,
  onRequestClose: () => void
  nextStep: () => void
}

export function Waiting({ source, onRequestClose, nextStep }: WaitingProps) {
  const dispatch = useDispatch<Dispatch>();

  React.useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      const end = new Date().getTime() + POLL_TIMEOUT;
      /* eslint-disable no-await-in-loop */
      let done = false;
      while (!cancelled && !done) {
        done = await dispatch(actions.getContactImportStatus(source));
        if (new Date().getTime() >= end) {
          break;
        }
        if (!done) {
          await delay(2000);
        }
      }
      /* eslint-enable no-await-in-loop */

      if (cancelled) {
        // Either dependencies changed or the component unmounted
      } if (done) {
        await dispatch(actions.loadContacts(true));
        await dispatch(actions.loadReferAFriendURL());
        nextStep();
      } else {
        onRequestClose();
      }
    };
    poll();
    return () => {
      cancelled = true;
    };
  }, [dispatch, nextStep, onRequestClose, source]);

  return (
    <HelloModal
      isOpen={true}
      data-qa-ref="import-contacts-waiting"
      showCloseIcon={true}
      contentLabel={
        <FormattedMessage
          id=""
          defaultMessage="waiting..."
          description="contact import page. import form, title, indicator for loading, informs user that import is in process" />

      }
      onRequestClose={onRequestClose}
    >
      <Body>
        <FormattedMessage
          id=""
          defaultMessage="This screen will update once the import is done."
          description="contact import page. import form, label, informs user that screen will be updated when importing will finish" />
      </Body>
    </HelloModal>
  );
}
